import { Box, Typography } from "@mui/joy";
import { Link } from "react-router-dom";
import { ChevronRight, Settings2 } from "lucide-react";

export default function Breadcrumb() {
    return (
        <Box p={2} pb={1} display={"flex"} alignItems={"center"} gap={1} flexWrap="wrap">
            <Link to="/admin/general">
                <Box display={"flex"} alignItems={"center"} gap={1}>
                    <Settings2 size={16} />
                    <Typography level="body-sm" color="neutral">
                        Platform Administration
                    </Typography>
                </Box>
            </Link>
            <ChevronRight size={16} />
            <Link to="/admin/organizations">
                <Typography level="body-sm" color="neutral">
                    Organizations
                </Typography>
            </Link>
            <ChevronRight size={16} />
            <Typography level="body-sm" color="primary">
                Edit Organization
            </Typography>
        </Box>
    );
}
